import { FETCH_GOLF_CLUB_TYPES, FETCH_GOLF_CLUB_TYPES_SUCCESS } from '../../actions/ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    payload: null
};

const fetchGolfClubTypesSuccess = (state, action) => {
    return {
        isFetching: false,
        payload: action.golfClubTypes
    };
};

const handlers = {
    [FETCH_GOLF_CLUB_TYPES_SUCCESS]: fetchGolfClubTypesSuccess
};

export default function golfClubTypes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export function fetchGolfClubTypes(evictCache) {
    return {
        type: FETCH_GOLF_CLUB_TYPES,
        isFetching: true,
        meta: {
            cacheTime: evictCache ? null : 2628000000 // one month - we rarely update these
        }
    };
}

export const getGolfClubTypes = (state) => {
    return state.golfClubTypes;
};
